import { Service } from 'models/Service';
import { browserFaqs } from '@/templates/Clarin/Service/components/FaqsBrowsers/data'; 

export class FrequentlyAskedQuestions extends Service {
  constructor() {
    super({
      adsPath: 'servicios/home',
      meta: {
        description: `Preguntas frecuentes de Clarin.com`,
        keywords: 'preguntas frecuentes',
        title: `Preguntas frecuentes`,
        url: 'preguntas-frecuentes',
        extra: [],
      },
      section: 'preguntas-frecuentes',
      sectionName: 'Preguntas frecuentes',
      template: 'FrequentlyAskedQuestions',
      title: `Preguntas frecuentes`,
      widthFull: false,
      slug: 'preguntas-frecuentes',
      titleHeader: 'Preguntas frecuentes',
    });
  }

  parseData = async (query) => {
    if (query[1]) {      
      const browser = query[1].split('.')?.[0];
      const data = browserFaqs[browser];
      this.setTemplate('FaqsBrowsers')      
      this.setMeta(
        this.parseMeta({
          description: `${data.title} - Clarín.com`,
          keywords: `preguntas frecuentes, ${browser}`,
          title: data.title,
          url: `preguntas-frecuentes/${query[1]}`,
          extra: [],
        })
      );
      this.setData({ content: data.content });
    }
  }
}
